import { render, staticRenderFns } from "./DataCards.vue?vue&type=template&id=c81af966&scoped=true&"
import script from "./DataCards.vue?vue&type=script&lang=js&"
export * from "./DataCards.vue?vue&type=script&lang=js&"
import style0 from "./DataCards.vue?vue&type=style&index=0&id=c81af966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81af966",
  null
  
)

export default component.exports